import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../components/common/Button';
import './CoachSignupSuccess.css';

const CoachSignupSuccess = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Auto-redirect to login after 5 seconds
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/login');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="success-page">
      <div className="success-container">
        <div className="success-icon">&#10003;</div>
        <h1>Payment Successful!</h1>
        <p className="success-message">
          Your coach account has been created. You can now log in and start building your team's workout program.
        </p>
        <p className="redirect-message">
          Redirecting to login in {countdown} seconds...
        </p>
        <Button variant="primary" onClick={() => navigate('/login')}>
          Log In Now
        </Button>
        <p className="help-text">
          <Link to="/">Return to Home</Link>
        </p>
      </div>
    </div>
  );
};

export default CoachSignupSuccess;
